import JSBBCCMembership from "../board-memberships/JSBBCCMembership";

export default function JSBBCDetails() {
  return (
    <div>
      <div className="government-bg bg-image">
        <div className="gap-spacer"></div>
        <div className="page-title top-cap-outlines">
          <h2>Joint School Board &amp; Borough Council Committee</h2>
        </div>

        <div className="content-fluid">
          <div className="mb-960-center-container mid-side-outlines ">
            <div className="mb-960-col-50p left-side-col-50p">
            <h4>Meetings</h4>
                <ul>
                  <li>7:00 p.m.</li>
                  <li>Held quarterly</li>
                    <ul>
                    <li>Feb 4, 2026</li>
                    <li>May 6, 2026</li>
                    <li>August 5, 2026</li>
                    <li>November 4, 2026</li></ul>
                  <li>
                    <a href="https://maps.app.goo.gl/1k9kD8H22ABx3e1g7">
                      <i className="fa-solid fa-location-pin"></i>&nbsp;Morrisville High School
                      <br />
                      550 W. Palmer Street
                      <br />
                      Morrisville, PA 19067
                    </a>
                    <br />
                  </li>
                  <li>
                  Meeting held in the EDI Room
                  </li>
                </ul>
                {/*
                <h4>Composition</h4>
                <ul>
                  <li>7 Members</li>
                  <li>3 year terms</li>
                  <li>Terms expire on the last day of March</li>
                </ul>    
  */}
              </div>
  
              <div className="mb-960-col-50p">
                
                <div className="council-members">
                  <JSBBCCMembership/>
                  </div>
              </div>
            </div>
          </div>
          <div className="page-footer bottom-cap-outlines">&nbsp;</div>
          <div className="gap-spacer"></div>
        </div>
      </div>
    )
  }